export default "__VITE_ASSET__28b9af02__"